import type { ExtendedFeaturesInstallDialogDto } from 'api/src/core/schemas/ProductSchema';
import { makeAutoObservable } from 'mobx';
import { z } from 'zod';
import type { StringDto } from '../../../../../../store/utils/Dto';
import extractValue, {
  type EventOrValue,
} from '../../../../../../store/utils/extractValue';
import Validator from '../../../../../../store/utils/Validator';
import { errorHandler } from '../../../../../../utils/errors';

export type { ExtendedFeaturesInstallDialogDto };

export default class InstallDialog {
  static readonly Schema = z.object({
    description: z.string(),
    title: z.string(),
  });

  description = '';
  title = '';

  private readonly validator = new Validator(this, InstallDialog.Schema);

  constructor(
    dto: ExtendedFeaturesInstallDialogDto | undefined,
    private readonly onSave: (hiseLink: InstallDialog) => Promise<void>,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });

    this.description = dto?.description || '';
    this.title = dto?.title || '';
  }

  get errors(): StringDto<ExtendedFeaturesInstallDialogDto> {
    return this.validator.errorsForEnabledFields;
  }

  handleChange(e: EventOrValue) {
    const { name, value } = extractValue(e);
    Object.assign(this, { [name]: value });
    this.validator.validate();
    this.save();
  }

  handleBlur(e: EventOrValue<keyof ExtendedFeaturesInstallDialogDto>) {
    const { name } = extractValue(e);
    this.validator.enableFieldValidation(name);
  }

  save() {
    this.onSave(this).catch(errorHandler('Cannot save hise link'));
  }

  toJSON(): ExtendedFeaturesInstallDialogDto | undefined {
    if (!this.description && !this.title) {
      return undefined;
    }

    return {
      description: this.description.trim(),
      title: this.title.trim(),
    };
  }
}
